

















import Enumerable from "linq";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { Component, Mixins } from "vue-property-decorator";
import { FormatStructureEditableMixin } from "../../mixins";
import { NameWarningItem } from "../../../../../domain/editableFormat";

@Component
export default class FormatObjectNameWarningTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  get nameWarningList(): NameWarningItem[] {
    const nameWarningObject = Enumerable.from(this.allPagesFormatObjects)
      .where(o => o.isSettableWarningName() && !!o.getWarningSettingName());
    // 重複しているものを削除
    const list = [] as NameWarningItem[];
    nameWarningObject.forEach(o => {
      if (!Enumerable.from(list).any(s => s.settingNameWarning === o.getWarningSettingName())) {
        list.push(new NameWarningItem(
          o.getWarningName(),
          o.getWarningSettingName(),
          Enumerable.from(this.nameWarningSetting.nameAlert.names).contains(o.getWarningSettingName()
      )));
      }
    });
    return list;
  }

  toName(row: NameWarningItem): string {
    return row.nameWarning;
  }

  getIsWarning(row: NameWarningItem): boolean {
    return row.isWarning;
  }

  setIsWaning(row: NameWarningItem, checked: boolean) {
    row.isWarning = checked;
    this.nameWarningSetting.nameAlert.names = Enumerable.from(this.nameWarningList)
      .where(s => s.isWarning)
      .select(s => s.settingNameWarning).toArray();
  }
}
